module.exports = __webpack_public_path__ + "static/media/logout.6278c5f9.svg";